import  MobileObjectTechService from './MobileObjectTechService'

export default MobileObjectTechService